import React, { useMemo } from 'react';
import Paper from '@material-ui/core/Paper';

import ActivityCard from 'components/ActivityCard';
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import { useStyles } from '../styles';

interface IProps {
  activityReport: any; // TODO: improve this
  currentTeam?: any; // TODO: improve this
  withoutPaper?: boolean;
  withoutIcon?: boolean;
  withoutTime?: boolean;
  withoutChip?: boolean;
}

const TimeCounter: React.FC<IProps> = ({
  activityReport,
  withoutPaper,
  withoutIcon,
  withoutTime,
  withoutChip,
}) => {
  const classes = useStyles();

  const mentionsDataCounter = useMemo(() => {
    if (!activityReport) return { avgTime: 0, count: 0, respondedCount: 0 };
    return (activityReport.mentionsGauges.length && activityReport.mentionsGauges[0]) || 0;
  }, [activityReport]);

  return (
    <>
      {!withoutPaper ? (
        <Paper className={classes.paper}>
          <ActivityCard
            icon={<AlternateEmailIcon style={{ marginRight: '5px' }} />}
            title={'Avg Response Time'}
            data={
              mentionsDataCounter.avgTime !== 0
                ? (mentionsDataCounter.avgTime / 60000).toFixed(1)
                : 0
            }
            post={'min'}
            withoutIcon={withoutIcon}
            withoutChip={withoutChip}
            withoutTime={withoutTime}
          />
        </Paper>
      ) : (
        <ActivityCard
          icon={<AlternateEmailIcon style={{ marginRight: '5px' }} />}
          title={'Avg Response Time'}
          data={
            mentionsDataCounter.avgTime !== 0 ? (mentionsDataCounter.avgTime / 60000).toFixed(1) : 0
          }
          post={'min'}
          withoutIcon={withoutIcon}
          float={true}
          withoutChip={withoutChip}
          withoutTime={withoutTime}
        />
      )}
    </>
  );
};

export { TimeCounter };
